import { jsx as _jsx, jsxs as _jsxs } from "nativewind/jsx-runtime";
import React from 'react';
import { View } from 'react-native';
import { ScreenLayout } from '@/components/ScreenLayout';
import { isFeatureEnabled } from '@/features/sandboxFeatures';
import BottomButtons from './components/BottomButtons';
import IdRow from './components/IdRow';
import MarketingPushAgreementRow from './components/MarketingPushAgreementRow';
import VersionRow from './components/VersionRow';
const SettingScreen = ({}) => {
    return (_jsxs(ScreenLayout, { isHeaderVisible: true, safeAreaEdges: ['bottom'], children: [_jsx(View, { className: "h-[26px]" }), _jsx(VersionRow, {}), _jsx(IdRow, {}), isFeatureEnabled('MARKETING_PUSH_AGREEMENT') && (_jsx(MarketingPushAgreementRow, {})), _jsx(View, { className: "flex-1" }), _jsx(BottomButtons, {})] }));
};
export default SettingScreen;
